<template>
<div>
    <vx-card>
      <div class="vx-col flex-1">
               <div class=" vx-row flex-1">
                   <div class=" vx-col flex-1"  v-if="$acl.check('admin')">
                      <vs-input :label="$t('CourseFeeToParticipant')" :disabled="true" v-model="CourseRequestModel.CourseFeeChargedToParticipant"  class="mt-5 w-full" name="CourseName"/>
                  </div>
                  <div class=" vx-col flex-1" >
                      <vs-select  autocomplete class="mt-5 w-full" :label="$t('Course') " v-model="CourseRequestModel.CourseID" @input="courseChanged">
                                 <vs-select-item  :value="0" :text="$t('OtherCourse')" style="background-color:#352566"/>
                                <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in courses" />
                      </vs-select>
                    <span class="text-danger text-sm"  v-show="errors.has('Course')">{{ errors.first('Course') }}</span>
                  </div>
                  <div class=" vx-col flex-1"  v-if="CourseRequestModel.CourseID==0||CourseRequestModel.CourseName">
                      <vs-input  :label="$t('CourseName')" v-model="CourseRequestModel.CourseName"  class="mt-5 w-full" name="CourseName"/>
                  </div>
                  <div class="vx-col flex-1" v-if="
                      CourseRequestModel.CourseID == 0 || CourseRequestModel.CourseName">
                          <vs-input
                          :label="$t('CourseDurationInDay')"
                          v-model="CourseRequestModel.CourseDurationInDay"
                          type="number"
                          class="mt-5 w-full"
                          name="CourseName"
                        />
                  </div>
                </div>

                  <div class=" vx-row flex-1" >
                    <div class=" vx-col flex-1" v-if="CourseRequestModel.CourseID!=0">
                        <vs-select  class="mt-5 w-full" :label="$t('CourseLanguage')"  v-model="CourseRequestModel.CourseLanguageID" >
                                  <vs-select-item  :value="0" :text="$t('OtherLanguage')" style="background-color:#352566"/>
                                  <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in languages" />
                        </vs-select>
                      <span class="text-danger text-sm"  v-show="errors.has('CourseLanguage')">{{ errors.first('CourseLanguage') }}</span>
                    </div>
                    <div class=" vx-col flex-1" v-if="CourseRequestModel.CourseLanguageID==0||CourseRequestModel.CourseLanguageName||CourseRequestModel.CourseID==0">
                      <vs-input  :label="$t('CourseLanguageName')" v-model="CourseRequestModel.CourseLanguageName"  class="mt-5 w-full" name="CourseLanguageName"/>
                    </div>
                </div>

                <div class=" vx-row flex-1" >
                    <div class=" vx-col flex-1"  v-show="CustomerTraineeSwitch==1" v-if="$acl.check('admin')">
                        <p>{{$t('Trainee')}}</p>
                          <v-select
                                label="FullName"
                                class=" w-full"
                                  autocomplete
                                v-model="CourseRequestModel.TraineeID"
                                :options="trainees"
                                :reduce="ID => ID.ID"
                              />
                        <span class="text-danger text-sm"  v-show="errors.has('Trainee')">{{ errors.first('Trainee') }}</span>
                   </div>
                </div>

           <div class="vx-row flex-1" >
               <div class=" vx-col flex-1" style="padding-top:20px ">
                  <label>{{$t('RequestStartDate')}}</label>
                  <datepicker  :disabledDates="disabledDates" name="Request Start Date" format="dd-MM-yyyy" v-model="CourseRequestModel.RequestStartDate" v-bind:v-validate="{required: true, date_format: 'dd-MM-yyyy'}"></datepicker>
                  <span class="text-danger text-sm"  v-show="errors.has('RequestStartDate')">{{ errors.first('RequestStartDate') }}</span>
               </div>
                <div class=" vx-col flex-1" style="padding-left:5px;padding-top:20px">
                  <p>{{$t('PaymentType')}}</p>
                      <v-select
                            label="Name"
                              class=" w-full"
                              autocomplete
                            v-model="CourseRequestModel.PaymentTypeID"
                            :options="PaymentTypes"
                            :reduce="ID => ID.ID"
                          />

                  <span class="text-danger text-sm"  v-show="errors.has('PaymentType')">{{ errors.first('PaymentType') }}</span>
                </div>
           </div>
          <div class="vx-row mt-5" >
            <div class="vx-col flex-1" >
               <p>{{$t('CourseType')}}</p>
                      <v-select
                                          label="Name"
                                           class="w-full"
                                            autocomplete
                                          v-model="CourseRequestModel.CourseTypeID"
                                          :options="getCourseType"
                                          :reduce="ID => ID.ID"
                                        />

            <span class="text-danger text-sm"  v-show="errors.has('CourseMode')">{{ errors.first('CourseMode') }}</span>
        </div>

         <div class="vx-col flex-1" >
            <p>{{$t('RequestLocation')}}</p>
                      <v-select
                                          label="Name"
                                           class="w-full"
                                            autocomplete
                                            @input="changeText"
                                          v-model="CourseRequestModel.RequestLocationID"
                                          :options="RequestLocations"
                                          :reduce="ID => ID.ID"
                                        />

            <span class="text-danger text-sm"  v-show="errors.has('RequestLocation')">{{ errors.first('RequestLocation') }}</span>
        </div>
        <div class="vx-col flex-1" v-if="CourseRequestModel.RequestLocationID==1">
            <p> {{$t('Location')}}</p>

           <vs-input  v-model="CourseRequestModel.LocationText"  class="w-full" name="LocationText"/>
            <span class="text-danger text-sm"  v-show="errors.has('LocationText')">{{ errors.first('LocationText') }}</span>
        </div>




             </div>

           </div>

    </vx-card>
    <div class="vx-row">
        <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
            <div>
              <vs-button class="mt-2 mr-5" type="border"  color="danger" @click="cancel">{{$t('Cancel')}}</vs-button>
              <vs-button class="ml-auto mt-2" @click="Submit" :disabled="!validateForm">{{$t('Submit')}} </vs-button>
            </div>
          </div>
        </div>
    </div>
</div>
</template>
<script>
// import CourseRequestMainData  from "@/views/courseRequest/CourseRequestMainData.vue"

import moduleCourseRequest from "@/store/courseRequest/moduleCourseRequest.js";
import moduleCourse from "@/store/course/moduleCourse.js";
import modulePaymentType from "@/store/settings/paymentType/modulePaymentType.js";
import moduleRequestLocation from "@/store/settings/requestLocation/moduleRequestLocation.js";
import moduleLanguage from "@/store/settings/language/moduleLanguage.js";
import Datepicker from 'vuejs-datepicker';
import moduleCourseType from "@/store/settings/courseType/moduleCourseType.js";
import vSelect from 'vue-select';
export default {
     components: {
       vSelect,
      // CourseRequestMainData,
      Datepicker
  },
  data(){
      return {
        disabledDates: {
        to: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()+30), // Disable all dates up to specific date
        from: new Date(new Date().getFullYear()+2, new Date().getMonth(), 1), // Disable all dates after specific date

        days: [1,2,3,4,5,6],
      },
          CourseRequestModel:{}
      }
  },
  computed:{
      getCourseType()
    {
        return this.$store.state.courseTypeList.courseTypes;
    },
      validateForm() {
        debugger
      return this.CourseRequestModel.RequestStartDate!=undefined  &&
      (
        (this.CourseRequestModel.RequestLocationID==1&&this.CourseRequestModel.LocationText!=undefined&&this.CourseRequestModel.LocationText!="")||this.CourseRequestModel.RequestLocationID==2)&&
      ( (this.$acl.check('trainee')||this.CourseRequestModel.NoOfTrainee!=undefined) ) && (this.CourseRequestModel.CourseID>0||this.CourseRequestModel.CourseName!=undefined)&&this.CourseRequestModel.PaymentTypeID>0&&this.CourseRequestModel.RequestLocationID>0;
    },
     courses() {
        return this.$store.state.courseList.courses;
        },
        PaymentTypes() {
         return this.$store.state.PaymentTypeList.PaymentTypes;
        },
        RequestLocations() {
          return this.$store.state.RequestLocationList.RequestLocations;
        },

        languages() {
           return this.$store.state.languageList.languages;
          //return this.$store.state.courseList.languages;
       },
  },
    created() {
       if (!moduleCourse.isRegistered) {
      this.$store.registerModule("courseList", moduleCourse);
      moduleCourse.isRegistered = true;
    }
    this.$store.dispatch("courseList/fetchDataListItems");

    if (!modulePaymentType.isRegistered) {
      this.$store.registerModule("PaymentTypeList", modulePaymentType);
      modulePaymentType.isRegistered = true;
    }
    this.$store.dispatch("PaymentTypeList/fetchDataListItems");

     if (!moduleRequestLocation.isRegistered) {
      this.$store.registerModule("RequestLocationList", moduleRequestLocation);
      moduleRequestLocation.isRegistered = true;
    }
    this.$store.dispatch("RequestLocationList/fetchDataListItems");

     if (!moduleLanguage.isRegistered) {
      this.$store.registerModule("languageList", moduleLanguage);
      moduleLanguage.isRegistered = true;
    }
    this.$store.dispatch("languageList/fetchDataListItems");

if (!moduleCourseRequest.isRegistered) {
      this.$store.registerModule("courseRequestList", moduleCourseRequest);
      moduleCourseRequest.isRegistered = true;
    }

     if (!moduleCourseType.isRegistered) {
      this.$store.registerModule("courseTypeList", moduleCourseType);
      moduleCourseType.isRegistered = true;
    }
     this.$store.dispatch("courseTypeList/fetchDataListItems");
    this.$store.commit("courseList/SET_CourseLanguages",[]);
    this.$store.commit("courseList/SET_CourseTypes",[]);
  },
  methods:{
    changeText(){
    if(this.CourseRequestModel.RequestLocationID==2){
     this.CourseRequestModel.LocationText ="";
    }
    },
      courseChanged()
      {
            this.GetLangaugesByCourseID(this.CourseRequestModel.CourseID);
      },
       GetLangaugesByCourseID(courseID)
        {
            this.$store.dispatch("courseList/GetLangaugesByCourseID",courseID);
        },
       cancel(){
      this.$router.push('/FollowCourseRequest');
    },
      notifyAlert(color,title,text) {
                this.$vs.notify({ time:8000,
                    color: color,
                    title: title,
                    text: text
                });
                },
      Submit()
      {
            if(this.CourseRequestModel.CourseID==0)
            {
            this.CourseRequestModel.Course=null;
            this.CourseRequestModel.CourseID=undefined;
            }
            if(this.CourseRequestModel.CourseLanguageID==0)
            {
                this.CourseRequestModel.Language=null;
                this.CourseRequestModel.CourseLanguageID=undefined;
            }
            debugger;
            this.CourseRequestModel.StatusID=10;
             this.CourseRequestModel.IsSendMail = true;
              this.$vs.loading();
            this.$store.dispatch("courseRequestList/addItem", this.CourseRequestModel).then(res=>{
                console.log(res);
                  this.$vs.loading.close();
              //  this.initValues();
                 this.notifyAlert("sucess",this.$t("Success"),this.$t("Yourrequestsubmittedsuccessfully"));
                  this.$router.push('/FollowCourseRequest');
            }).catch(()=>{
                this.$vs.loading.close();
                  this.notifyAlert("danger",this.$t("Error"),this.$t("Unexpectederrorpleasetryagain"));
            });
      }
  }
}
</script>
